import { useEffect, useState } from 'react';
import { useAlertBannerData } from './useAlertBannerData';
import * as AnnualBillingUpsell from '../banners/AnnualBillingUpsell';
import * as BannerMessage from '../banners/BannerMessage';
import * as CompaniesTrialEnded from '../banners/CompaniesTrialEnded';
import * as CompaniesTrialing from '../banners/CompaniesTrialing';
import * as EnterpriseTrialEnded from '../banners/EnterpriseTrialEnded';
import * as EnterpriseTrialing from '../banners/EnterpriseTrialing';
import * as ProfessionalTrialEnded from '../banners/ProfessionalTrialEnded';
import * as ProfessionalTrialing from '../banners/ProfessionalTrialing';
import * as RefreshRequired from '../banners/RefreshRequired';
import * as TeamsDowngraded from '../banners/TeamsDowngraded';
import * as TeamsTrialEnded from '../banners/TeamsTrialEnded';
import * as OverdueInvoice from '../banners/OverdueInvoice';
import * as TeamsTrialing from '../banners/TeamsTrialing';
import * as TaskUsage from '../banners/TaskUsage';
import * as Workspaces from '../banners/Workspaces';
import * as UnlimitedAccount from '../banners/UnlimitedAccount';
import * as AnnualPlanRenewalNotice from '../banners/AnnualPlanRenewalNotice';
const possibleComponents = [
    RefreshRequired,
    Workspaces,
    TaskUsage,
    BannerMessage,
    UnlimitedAccount,
    CompaniesTrialing,
    CompaniesTrialEnded,
    EnterpriseTrialing,
    EnterpriseTrialEnded,
    TeamsTrialing,
    TeamsTrialEnded,
    OverdueInvoice,
    AnnualPlanRenewalNotice,
    TeamsDowngraded,
    ProfessionalTrialing,
    ProfessionalTrialEnded,
    AnnualBillingUpsell,
];
export const useAlertBanner = () => {
    var _a;
    const [lastRenderedTime, setLastRenderedTime] = useState(Date.now());
    const [isExcludedUrl, setIsExcludedUrl] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setLastRenderedTime(Date.now());
        }, 5 * 60 * 60 * 1000);
    }, [lastRenderedTime]);
    useEffect(() => {
        setIsExcludedUrl(window.location.pathname.includes('team-account-setup'));
    }, []);
    const { isLoading, isError, data } = useAlertBannerData();
    const Component = isLoading || isError || !data
        ? undefined
        : (_a = possibleComponents.find((component) => {
            return component.shouldRender(data, isExcludedUrl);
        })) === null || _a === void 0 ? void 0 : _a.Component;
    return {
        data,
        Component,
        isLoading,
    };
};
//# sourceMappingURL=useAlertBanner.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
